export default "__VITE_ASSET__2uj2CTcD__"